import { DialogContent, DialogContentProps } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  sx?: DialogContentProps["sx"];
}

export default function AppModalContent({ children, sx }: Props) {
  return <DialogContent sx={sx}>{children}</DialogContent>;
}
